import gsap, { Power3 } from 'gsap';
import { onDomReady } from '../utils/dom';

function initFilter() {
    /** @type {HTMLSelectElement|null} */
    const filter = document.querySelector('.mod_eventmenu select');
    const items = document.querySelectorAll('[data-month]');

    if (!filter || items.length === 0) {
        return;
    }

    import('gsap/Flip').then(({ Flip }) => {
        gsap.registerPlugin(Flip);

        function updateFilters() {
            const state = Flip.getState(items);

            // adjust the display property of each item
            items.forEach((item) => {
                const month = item.dataset.month;
                item.style.display = filter.value && month !== filter.value ? 'none' : 'block';
            });

            const stagger = window.innerWidth > 768 && window.innerWidth < 992 ? 0 : 0.08;

            // animate from the previous state
            Flip.from(state, {
                duration: 0.5,
                stagger,
                ease: Power3.easeOut,
                onEnter: (elements) =>
                    gsap.fromTo(
                        elements,
                        { opacity: 0, y: 100 },
                        { opacity: 1, y: 0, duration: 0.7, stagger, ease: Power3.easeOut }
                    ),
                onLeave: (elements) => gsap.to(elements, { opacity: 0, duration: 0 }),
            });
        }

        filter.addEventListener('change', updateFilters);
    });
}

onDomReady(() => {
    initFilter();
});
